import React from 'react'
import { Layout } from 'antd'
import TopHeader from '../topheader/TopHeader'
import Contents from '../contents/Contents';
import SideMenu from '../sidemenu/SideMenu';
import './Docs.css'

export default function Docs() {
  return (
    <Layout>
     <Contents></Contents>
     <SideMenu></SideMenu>
     <TopHeader></TopHeader>
    </Layout>
  )
}
